import InputText from '../../../TextInput/TextInput';
import TextArea from '../../../TextArea/TextArea';
import {Subtitle, InputWrapper, TabContainer} from './Tabs.styled';
import {observer} from "mobx-react";
import {useTemplateEditorStore} from "../../hook";
import {useMemo} from "react";
import CustomSelect from "../../../../select/CustomSelect";
import {useUserCheckPermissions} from "../../../../../hooks/useUserCheckPermissions";
import {PermissionCodes} from "../../../../../utils/enums";

// TODO: Replace hardcoded domain with API endpoint when available
const HARDCODED_DOMAINS = [
  "development.annaims.com",
  "staging.aimsos.ai",
  "mail.aimsos.ai",
];

const GeneralTab = observer(() => {
  const {requiredFieldsError, formEditorStore} = useTemplateEditorStore();
  const {fromDomain, senderName, to, subject, cc, bcc, description, validateSenderName} = formEditorStore;
  const {checkPermission} = useUserCheckPermissions();

  const domainOptions = useMemo(
    () => HARDCODED_DOMAINS.map(domain => ({name: domain, value: domain})),
    []
  );

  return (
    <>
      {(checkPermission(PermissionCodes.GENERAL_SETUP, "UPDATE")) && (
        <TabContainer>
          <h1>General</h1>
          <InputWrapper>
              <Subtitle>From*</Subtitle>
              <CustomSelect
                  width={"100%"}
                  placeholder="Select domain"
                  selectedDefault={fromDomain}
                  options={domainOptions}
                  searchBar={false}
                  handleSelect={(e) => formEditorStore.updateField('fromDomain', e)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>Sender Name*</Subtitle>
              <InputText
                  placeholder="Please enter your name"
                  value={senderName ? senderName.toLowerCase() : ''}
                  displayError={(requiredFieldsError || validateSenderName) && !senderName}
                  validationError={validateSenderName ? validateSenderName : "Sender name is required for sending this message."}
                  onBlur={() => formEditorStore.updateSenderName()}
                  onChange={(e) => formEditorStore.updateField("senderName", e.target.value)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>To</Subtitle>
              <InputText
                  placeholder="To"
                  value={to}
                  disabled={true}
                  onChange={(e) => formEditorStore.updateField('to', e.target.value)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>Subject*</Subtitle>
              <InputText
                  placeholder="Subject"
                  value={subject}
                  displayError={requiredFieldsError && !subject}
                  validationError={"Subject is required for sending this message."}
                  onChange={(e) => formEditorStore.updateField("subject", e.target.value)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>CC</Subtitle>
              <InputText
                  placeholder="CC"
                  value={cc}
                  onChange={(e) => formEditorStore.updateField('cc', e.target.value)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>BCC</Subtitle>
              <InputText
                  placeholder="BCC"
                  value={bcc}
                  onChange={(e) => formEditorStore.updateField('bcc', e.target.value)}
              />
          </InputWrapper>

          <InputWrapper>
              <Subtitle>Description (optional)</Subtitle>
              <TextArea
                  placeholder="Enter a description"
                  height="120px"
                  resize="none"
                  value={description}
                  onChange={(e) => formEditorStore.updateField('description', e.target.value)}
              />
          </InputWrapper>
        </TabContainer>
      )}
    </>
  );
});

export default GeneralTab